import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { DaftarPenilaianPeriodik } from 'app/KinerjaGpkPage/pages/pejabat-penilai-kinerja/periodik/DaftarPenilaianPeriodik'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaGpkEnabled = toggle?.['kinerja-gpk-enabled'] || false
    const isKinerjaGpkPeriodikEnabled =
      toggle?.['kinerja-gpk-periodik-enabled'] || false

    if (!isKinerjaGpkEnabled || !isKinerjaGpkPeriodikEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return {
      props: {},
    }
  },
})

export default function Page() {
  return (
    <PageGuardDinas>
      <DaftarPenilaianPeriodik />
    </PageGuardDinas>
  )
}

Page.Layout = KinerjaLayout
